class Tabs {
  constructor() {
    this.init();
  }

  init() {
    //Info-box mobile Accordion
    const tabs = document.getElementsByClassName('wav-tabs-item');
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        /* Toggle between adding and removing the "active" class,
          to highlight the button that controls the panel */
        this.classList.toggle('active');

        [...this.parentNode.children]
          .filter((child) => child !== this)
          .forEach(function (item) {
            item.classList.remove('active');
          });

        /* Toggle between hiding and showing the active panel */
        const content = this.querySelector('div.content');
        const contentBox = this.closest('wav-tabs').querySelector('.wav-tabs-content');

        contentBox.innerHtml = content.innerHtml;
      });
    }
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./scripts/modules/Tabs.js